export function useHtmlParser() {
    const parseHtml = (html: string) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        return doc.body.textContent ?? '';
    };

    return { parseHtml };
}
